import { createSlice } from '@reduxjs/toolkit';
import {
  CLEAR_CHECKED_LAYERS,
  TOGGLE_SPATIAL_LAYER,
} from 'emergency_data/src/actions/actionTypes';
import { saveSchema } from '@rsos/schema-storage';

const LAYER_KEYS = {
  EAGLE_EYE: 'eagle_eye_camera_feeds',
};

const initialState = {
  datasets: {},
  currentSelectedCallerID: null,
  // Toggle visibility of the spatial layer (and its DeckGL layers).
  visible: true,
};

const eagleEyeSlice = createSlice({
  name: 'eagleEyeSlice',
  initialState,
  reducers: {
    handleEagleEye(state, action) {
      const topic = `${action?.payload?.topic}`.split('tel://')[1];
      const { data = [] } = action.payload.body;
      if (topic === state.currentSelectedCallerID) {
        state.datasets = {
          ...{ [topic]: data },
        };
      }
    },
    setCurrentSelectedCallerID(state, action) {
      state.currentSelectedCallerID = action.payload;
    },
    resetEagleEye(state) {
      return (state = {
        datasets: {},
        currentSelectedCallerID: null,
        visible: state.visible,
      });
    },
  },
  extraReducers: {
    [TOGGLE_SPATIAL_LAYER]: (state, action) => {
      const { isChecked, layerKey } = action;
      if (layerKey === LAYER_KEYS.EAGLE_EYE) {
        state.visible = isChecked;
      }
    },
    [CLEAR_CHECKED_LAYERS]: state => {
      state.visible = false;
    },
  },
});

export const {
  handleEagleEye,
  resetEagleEye,
  setCurrentSelectedCallerID,
} = eagleEyeSlice.actions;
export default eagleEyeSlice.reducer;

export const handleEagleEyeRawMessage = (action = {}) => dispatch => {
  const { layer = {} } = action.body;
  dispatch(saveSchema({ id: layer.key, schema: layer }));
  dispatch(handleEagleEye(action));
};
